import { BaseSingletonService, Singleton } from './service.base';
import { SignInDialogService } from './service.signin.dialog';
import { LinkAccountDialogService } from './service.link.account.dialog';
import { RedeemDialogService } from './service.redeem.dialog';
import { VerificationCodeDialogService } from './service.verification.code.dialog';
import { PrivacyPolicyDialogService } from './service.privacy.policy.dialog';
import { AlertDialogService } from './service.alert.dialog';
import { RemoveCardDialogService } from './service.remove.card.dialog';
import { ForbiddenAlertDialogService } from './service.forbidden.alert.dialog';

@Singleton()
export class DialogService extends BaseSingletonService {
    constructor(
        public signInDialogSrv: SignInDialogService,
        public linkAccountDialogSrv: LinkAccountDialogService,
        public redeemDialogSrv: RedeemDialogService,
        public verificationCodeDialogSrv: VerificationCodeDialogService,
        public privacyPolicyDialogSrv: PrivacyPolicyDialogService,
        public alertDialogSrv: AlertDialogService,
        public removeCardDialogSrv: RemoveCardDialogService,
        public forbiddenAlertDialogSrv: ForbiddenAlertDialogService,
    ) {
        super();
    }
}
